import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {fetchPatientDetailsUuid, postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import './stimulationStartingChecklist.scss';
export default function StimulationStartingChecklist(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const stimulationHeaders = [
    {key: 'sno', label: 'Sl No.'},
    {key: 'factor', label: 'Factors'},
    {key: 'male', label: 'Male'},
    {key: 'female', label: 'Female'}
  ];

  const [showTables, setShowTables] = useState({
    stimulation: true
  });

  const factorList = [
    'HB',
    'PCV',
    'PLT',
    'RBS/FBS',
    'HBA1C',
    'TSH',
    'FT4',
    'HIV/',
    'VDRL',
    'HBSAG',
    'HCV',
    'AMH',
    'PROLACTIN',
    'BT/CT',
    'PT/INR',
    'UREA/CR',
    'KARYOTYPING',
    'X RAY/ECHO',
    'ECG',
    'SA',
    'DFI',
    'FSH MALE',
    'TESTOSTERONE MALE',
    'ADMIN CHECKLIST',
    'FINANCIAL COUNSELLING',
    'CONSENT',
    'SEMEN FREEZING',
    'ADVANCED SPERM SELECTION MICROFLUIDCS/ PICSI',
    'PGT',
    'MARRIAGE CERTIFICATE',
    'AADHAR'
  ];

  const generateInitialRows = () =>
    factorList.map((label, idx) => ({
      sno: (idx + 1).toString(),
      factor: label,
      male: '',
      female: ''
    }));

  const [stimulationRows, setStimulationRows] = useState(generateInitialRows());

  const [patientOne_UUId, setPatientOne_UUId] = useState('');
  let bmiValue = formData?.height && formData?.weight ? ((formData.weight / formData.height ** 2) * 10000).toFixed(2) : '';
  const labelStyles = {
    fontWeight: '600',
    marginRight: '5px',
    width: 'max-content'
  };
  const handleChange = e => {
    // const { name, value } = e.target;
    // setFormData({ ...formData, [name]: value });
    var text = e.target.value;

    if (e.target.name === 'patientId1') {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === 'A') {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            if (e.target.name === 'patientId1') {
              setPatientOne_UUId(data?.id);
              setFormData({
                ...formData,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId1') {
          setFormData({
            ...formData,
            patientId1: e.target.value
          });
        }
      }
    } else {
      console.log('Going in');
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const {styleSec = {}, styleLabel = {}, styleSpan = {}} = options;

    return (
      <>
        <section style={{...styleSec, margin: '0 10px 10px 10px', display: 'flex'}}>
          <label
            style={{
              ...styleLabel,
              fontWeight: '600',
              marginRight: '5px',
              width: 'max-content'
            }}>
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };
  const renderInput = (name, type = 'text', size) => (
    <>
      <input type={type} name={name} className={`createTime ${show ? 'hide' : 'show'}`} onChange={handleChange} style={{width: size}} />
      <span className={`bookinginput ${!show ? 'hide' : 'show'}`}>&nbsp;{formData[name]}</span>
    </>
  );
  const renderSelect = (name, options, size) => (
    <>
      <select name={name} className={`createTime ${show ? 'hide' : 'show'}`} onChange={handleChange} style={{border: '1px solid black', width: size}}>
        <option disabled selected>
          select
        </option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
      <span style={{fontWeight: '400'}} className={`bookinginput ${!show ? 'hide' : 'show'}`}>
        &nbsp;{formData[name]}
      </span>
    </>
  );
  const renderTableTD = (value, options = {}) => {
    const {style = {border: '1px solid black', textAlign: 'center'}} = options;
    return <td style={style}>{value}</td>;
  };
  const renderTableTH = (value, options = {}) => {
    const {style = {border: '1px solid black', textAlign: 'center'}} = options;
    return <th style={style}>{value}</th>;
  };
  const renderIndentation = () => (
    <span
      style={{
        visibility: 'hidden',
        fontSize: '30px',
        lineHeight: '20px'
      }}>
      ●
    </span>
  );
  const renderDiscPoint = () => (
    <span
      style={{
        fontSize: '30px',
        // lineHeight: "20px",
        display: 'flex',
        alignItems: 'center',
        height: '20px'
      }}>
      ●
    </span>
  );

  const handlesubmit = () => {
    props.loaderchange('true');

    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && props.patientsData.p_uhid.length === 10) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById('prescriptionReportWrap').innerHTML;

          // Prepare payload for creating report
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Stimulation Starting Checklist'
            }
          };
          /*  const createNewAppointment = async () => {
            console.log(appointmentData);
            await dispatch(postAppointment(appointmentData));
          };
          createNewAppointment(); */
          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
            Swal.fire({
              title: 'Successful.',
              text: 'Record added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const handleNill = id => {
    setShowTables(prev => ({...prev, [id]: false}));
  };

  return (
    <div id='EtTemplate'>
      <div className='EtTemplate'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              gap: '3px',
              backgroundColor: '#f7f7f7 ',
              borderRadius: '6px',
              padding: '16px 8px 16px 8px',
              gap: '3px'
            }}>
            <div style={{display: 'flex', gap: '16px', alignItems: 'center'}}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '125px 16px 250px',
                  alignItems: 'center '
                }}>
                <span style={{fontWeight: 600}}>Patient ID</span>
                <span style={{fontWeight: 600}}>: </span>
                <input
                  type='text'
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  value={props.patientsData.p_uhid}
                  onChange={e => handleChange(e)}
                  name='patientId'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px'
                  }}
                />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.p_uhid}</span>
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '125px 16px 250px',
                alignItems: 'center '
              }}>
              <span style={{fontWeight: 600}}>Patient Name</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name='patientName'
                style={{
                  border: '1px solid #ddd',
                  outline: 'none',
                  padding: '10px',
                  color: '#000'
                }}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`} style={{width: '100%'}}>
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px'
              }}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '125px 16px 250px',
                  alignItems: 'center '
                }}>
                <span style={{fontWeight: 600}}>Gender</span>
                <span style={{fontWeight: 600}}>: </span>
                <select
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  onChange={e => handleChange(e)}
                  value={props.patientsData.gender}
                  name='gender'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px',
                    backgroundColor: 'white'
                  }}>
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                  <option value='Others'>Others</option>
                  <option value='Decline to State'>Decline to State</option>
                </select>
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.gender}</span>
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '125px 16px 250px',
                alignItems: 'center '
              }}>
              <span style={{fontWeight: 600}}>Age</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={props.patientsData.age}
                name='age1'
                style={{
                  border: '1px solid #ddd',
                  outline: 'none',
                  padding: '10px'
                }}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.age}</span>
            </div>
          </div>

          <div className='row mt-2'>
            <h4 className='mt-4'>PATIENT INFORMATION</h4>

            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Height :' name='height' value={formData.height} required={false} onChange={handleChange} inputClassName='show' endLabel='cm' />
            </div>

            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Weight :' name='weight' value={formData.weight} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='BMI :' name='bmi' value={bmiValue} required={false} onChange={handleChange} inputClassName='show' endLabel='kg/m2' />
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='PR :' name='pr' value={formData.pr} required={false} onChange={handleChange} inputClassName='show' endLabel='bpm' />
            </div>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='Blood Pressure (BP) :' name='bp' value={formData.bp} required={false} onChange={handleChange} inputClassName='show' endLabel='mmHg' minWidth='200px' />
            </div>
          </div>
          <div className='detail'>
            <h3 style={{textAlign: 'center'}}>Others</h3>
            <h3 style={{textAlign: 'center'}}>STIMULATION STARTING CHECKLIST</h3>
          </div>
        </div>
        <div className='detail'>
          {showTables.stimulation && (
            <TemplateTable
              id='stimulation'
              title=''
              headers={stimulationHeaders}
              rows={stimulationRows}
              onRowsChange={(id, newRows) => setStimulationRows(newRows)}
              enableActions={true}
              onNill={handleNill}
            />
          )}
        </div>
        <p style={{fontWeight: '600'}}>
          NEXT APPOINTMENT -{' '}
          <input
            name='nextappointment'
            onChange={handleChange}
            type='datetime-local'
            // type="date"
          />
        </p>
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>

      <div id='prescriptionReport'>
        <div id='prescriptionReportWrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', marginTop: '10px'}}>
            <h4 style={{fontWeight: 600, marginRight: '5px'}}>PATIENT INFORMATION</h4>
          </div>
          <div style={{display: 'flex', marginTop: '10px'}}>
            {renderReportfield('Height :', `${formData.height ? formData.height : ''} cm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Weight :', `${formData.weight ? formData.weight : ''} kg`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('BMI :', `${bmiValue ? bmiValue : ''} kg/m2`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}

            {renderReportfield('PR :', `${formData.pr ? formData.pr : ''} bpm`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
            {renderReportfield('Blood Pressure (BP) :', `${formData.bp ? formData.bp : ''} mm Hg`, {
              styleSec: {margin: '0 10px 10px 10px', display: 'flex'},
              styleLabel: labelStyles
            })}
          </div>

          <div style={{marginTop: '10px'}}>
            <h3 style={{textAlign: 'center'}}>Others</h3>
            <h3 style={{textAlign: 'center'}}>STIMULATION STARTING CHECKLIST</h3>
          </div>
          {showTables.stimulation && (
            <div>
              <table style={{width: '100%'}}>
                <tr>{['SI No.', 'Factors', 'Male', 'Female'].map(ele => renderTableTH(ele))}</tr>
                <tbody>
                  {stimulationRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.sno)}
                      {renderTableTD(row.factor)}
                      {renderTableTD(row.male)}
                      {renderTableTD(row.female)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div style={{marginTop: '10px'}}>{renderReportfield('Next Appointment : ', appointmentData.date?.split('-').reverse().join('-'))}</div>
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
